const CALCULATION_TEXT = 'Calculation';

// These constants are used w/in subQueries, for setting the concept & output uri's
export const CALCULATION_URIS = {
  plural: CALCULATION_TEXT + 's',
  singular: CALCULATION_TEXT,
};

// This constant is used throughout Studio
// - domain name validation
// - subQuery outputs
// - Edit Questions > Filter preview
// - Edit Questions > Calculation modal
export const CALCULATION_CONCEPT_LABELS = {
  plural: CALCULATION_TEXT + 's',
  singular: CALCULATION_TEXT,
};

// This constant is used throughout Edit Questions view, in html selects, to be able to have additional context in the html option value
export const OUTPUT_SPLIT_CHAR = '####';
